import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

import addEditRequest from './modules/addEditRequest';
import requests from './modules/requests';
import users from './modules/users';
import leaveTypes from './modules/leaveTypes';
import addEditUser from './modules/addEditUser';
import requestStatuses from './modules/requestStatuses';
import userRoles from './modules/userRoles';
import currentUser from './modules/currentUser';


const store = new Vuex.Store({
  strict: false,
  modules: {
    addEditRequest,
    requests,
    addEditUser,
    leaveTypes,
    currentUser,
    userRoles,
    requestStatuses,
    users,
  },
  state: {
    globalLoading: false,
  },
  actions: {},
  mutations: {
    setGlobalLoading(state: any, payload: boolean): void {
      Vue.set(state, 'globalLoading', payload);
    },
  },
  getters: {
    globalLoading: (state: any): boolean => state.globalLoading,
  },
  plugins: [new VuexPersist({
    modules: ['users', 'leaveTypes', 'currentUser'],
  }).plugin],
});

export default store;
